export const SENTRY_URL =
  'https://6db37eb0852f9d643014cc6b2a98946a@sentry.platform-shared.aws.attensi.com/27'